/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { TranslocoLocaleModule, provideTranslocoLocale } from '@jsverse/transloco-locale';
import { AeroModule } from '../../../aero/aero.module';
import { ShutdownAlertComponent } from './shutdown-alert.component';

/**
 * Module for displaying shutdownAlertComponent alert.
 */
@NgModule({
  declarations: [ShutdownAlertComponent],
  imports: [
    AeroModule,
    CommonModule,
    TranslocoModule,
    TranslocoLocaleModule,
  ],
  providers: [
    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        es: 'es-ES',
        pt: 'pt-PT',
        de: 'de-DE',
        fi: 'fi-FI',
        fr: 'fr-FR',
        sv: 'sv-SV',
        no: 'no-NO',
        nl: 'nl-NL',
      },
    }),
  ],
  exports: [ShutdownAlertComponent],
})
export class ShutdownAlertModule { }
